import { render, staticRenderFns } from "./open-invoice-order.vue?vue&type=template&id=1ad6b8a2&"
import script from "./open-invoice-order.vue?vue&type=script&lang=js&"
export * from "./open-invoice-order.vue?vue&type=script&lang=js&"
import style0 from "./open-invoice-order.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports